export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_ID || "";

export const pageview = (url: string) => {
  if (!GA_TRACKING_ID) return;
  window.gtag("config", GA_TRACKING_ID, {
    page_path: url,
  });
};

export const event = (param: { [key: string]: any }) => {
  if (!GA_TRACKING_ID) return;
  // window.gtag('event', eventName, {
  //   value: value,
  // });
  window.dataLayer?.push(param);
};
